<div class="row" style="overflow-y: auto">
  <div class="col-12"><app-general-form-info-moha [check]="1" [maxSize]="maxSize"></app-general-form-info-moha></div>
  <div class="col-12"><app-record-party-sign-moha [check]="1"></app-record-party-sign-moha></div>
  <div class="col-12" style="padding-right: 12px"><app-general-form-info-moha [check]="2" [maxSize]="maxSize"></app-general-form-info-moha></div>
</div>

